import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';

type TGenericModalFooterProps = {
  onSave: () => void;
  saving?: boolean;
  disabled?: boolean;
  disabledOpacity?: number;
  disableCancel?: boolean;
  handleClose: () => void;
  backgroundColor?: string;
  saveText?: string;
  className?: string;
};

const GenericModalFooter = ({
  backgroundColor = 'inherit',
  onSave,
  saving,
  disabled,
  disabledOpacity,
  disableCancel,
  handleClose,
  saveText = 'Save',
  className = '',
}: TGenericModalFooterProps) => {
  return (
    <Container
      background={backgroundColor}
      width="100%"
      height="100%"
      maxWidth="100%"
      className={`flex fd-row jc-flex-end ai-center ${className}`}
      margin="0 auto"
    >
      <Container className="flex fd-row jc-flex-start ai-center gap-16">
        <Button
          onClick={handleClose}
          design="LocalBttnSec"
          className="L1 flex ai-center jc-center"
          width="95px"
          height="48px"
          disabled={disableCancel}
        >
          <Text>Cancel</Text>
        </Button>
        <Button
          backgroundColor={getThemeColorCSSVariable()}
          height="48px"
          minWidth="81px"
          disabled={disabled}
          disabledOpacity={disabledOpacity}
          loading={saving}
          onClick={onSave}
          hoverOpacity={0.9}
          className="flex ai-center jc-center L1"
        >
          <Text
            color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            className="L1"
          >
            {saveText}
          </Text>
        </Button>
      </Container>
    </Container>
  );
};

export default GenericModalFooter;
